import { render, staticRenderFns } from "./company-signup.vue?vue&type=template&id=e2c0beb4&lang=pug&"
import script from "./company-signup.vue?vue&type=script&lang=js&"
export * from "./company-signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports